import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function createForm(body) {
    try {
        return await axios.post(`${LEADS_ENDPOINT}/form`, body)
    } catch(error) {
        throw new Error(error)
    }
}
